import React, { useState } from 'react'

import { Button, makeStyles, Paper, Typography } from '@material-ui/core'

import useLogin from '../../hooks/useLogin'

import { isDevOrLocalOrTest } from '~/config/helpers'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import { LoginMock } from '~/login'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: 'url(/bg.jpg)',
    backgroundSize: 'cover',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  title: {
    display: 'block',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(12),
  },
  paper: {
    padding: theme.spacing(12),
    width: '456px',
    height: '284px',
  },
  logo: {
    marginTop: theme.spacing(6),
  },
}))
export default function Login() {
  const { runtimeConfig } = useAppDepsContext()
  const { authenticate, authenticateDev } = useLogin()
  const styles = useStyles()

  const isDevEnv = isDevOrLocalOrTest(runtimeConfig.environment)

  const [isOpenLoginMock, setIsOpenLoginMock] = useState(false)

  function onCloseLoginMock() {
    setIsOpenLoginMock(false)
  }

  function onAuthenticate() {
    if (isDevEnv) {
      setIsOpenLoginMock(true)
    } else {
      authenticate()
    }
  }

  return (
    <div className={styles.root} data-hook="login-widget">
      <Paper className={styles.paper}>
        <svg
          className={styles.logo}
          xmlns="http://www.w3.org/2000/svg"
          width="238"
          height="21"
          viewBox="0 0 238 21"
        >
          <g fill="none" fillRule="evenodd">
            <path
              fill="#878787"
              d="M9.967.166c2.902 0 4.79.767 6.543 2.053.246.192.438.493.438.876 0 .603-.493 1.096-1.068 1.096-.246 0-.465-.11-.684-.274-1.369-1.04-2.901-1.752-5.31-1.752-4.243 0-7.282 3.586-7.282 7.856v.054c0 4.572 2.929 7.967 7.583 7.967 2.19 0 4.215-.85 5.53-1.917v-4.763H10.57c-.52 0-.958-.438-.958-.958 0-.547.438-.985.958-.985h6.159c.574 0 1.068.492 1.068 1.095v5.83c0 .52-.247.986-.74 1.314-1.751 1.287-4.106 2.327-6.952 2.327-6.023 0-9.746-4.38-9.746-9.855v-.055C.36 4.82 4.22.166 9.967.166zm72.846 0c5.831 0 9.745 4.572 9.745 9.855v.054c0 5.284-3.969 9.91-9.8 9.91-5.83 0-9.745-4.572-9.745-9.855v-.055c0-5.283 3.97-9.909 9.8-9.909zm103.563 0c5.83 0 9.745 4.572 9.745 9.855v.054c0 5.284-3.97 9.91-9.8 9.91s-9.745-4.572-9.745-9.855v-.055c0-5.283 3.97-9.909 9.8-9.909zM53.22.358c.575 0 1.068.493 1.068 1.095v10.019c0 5.584-3.203 8.486-7.993 8.486-4.736 0-7.966-2.902-7.966-8.322V1.453c0-.602.493-1.095 1.067-1.095.603 0 1.096.493 1.096 1.095v10.046c0 4.133 2.217 6.46 5.858 6.46 3.531 0 5.776-2.135 5.776-6.323V1.453c0-.602.492-1.095 1.094-1.095zm159.654 0c.603 0 1.068.493 1.068 1.04 0 .164-.028.302-.082.438l-7.418 17.136c-.247.547-.63.904-1.26.904h-.11c-.629 0-1.039-.357-1.258-.904l-7.391-17.054c-.082-.164-.11-.3-.11-.492 0-.548.493-1.068 1.095-1.068.548 0 .931.356 1.122.821l6.625 15.877 6.652-15.932c.192-.383.575-.766 1.067-.766zM28.994.495c2.354 0 4.242.711 5.447 1.916.931.93 1.478 2.272 1.478 3.777v.055c0 3.148-2.135 4.982-5.119 5.557l4.764 6.132c.218.246.355.492.355.794 0 .575-.547 1.067-1.095 1.067-.438 0-.766-.246-1.013-.574L28.42 12.21h-5.503v6.487c0 .603-.492 1.095-1.094 1.095-.575 0-1.068-.492-1.068-1.095V1.59c0-.603.493-1.095 1.068-1.095h7.172zM217.392.358c.603 0 1.095.493 1.095 1.095v17.245c0 .603-.492 1.095-1.095 1.095-.574 0-1.067-.492-1.067-1.095V1.453c0-.602.493-1.095 1.067-1.095zM64.663.495c4.326 0 7.173 2.299 7.173 6.077v.055c0 4.133-3.45 6.268-7.528 6.268h-4.654v5.803c0 .603-.493 1.095-1.095 1.095-.575 0-1.067-.492-1.067-1.095V1.59c0-.603.492-1.095 1.067-1.095h6.104zm92.312-.082c.465 0 .794.246 1.012.574l6.844 10.293L171.674.987c.22-.355.575-.574 1.013-.574h.246c.576 0 1.068.493 1.068 1.067v17.218c0 .603-.492 1.095-1.068 1.095-.602 0-1.094-.52-1.094-1.095V4.41l-6.132 9.006c-.247.356-.52.548-.903.548-.384 0-.685-.192-.931-.548l-6.104-8.978v14.289c0 .602-.466 1.067-1.068 1.067-.575 0-1.04-.465-1.04-1.067V1.48c0-.574.493-1.067 1.067-1.067h.247zm67.234-.055c.602 0 1.095.493 1.095 1.095v16.205h9.936c.548 0 .986.466.986 1.013 0 .547-.438.985-.986.985H224.21c-.575 0-1.068-.492-1.068-1.095V1.453c0-.602.493-1.095 1.068-1.095zM82.759 2.165c-4.38 0-7.5 3.503-7.5 7.856v.054c0 4.353 3.174 7.911 7.554 7.911 4.38 0 7.5-3.503 7.5-7.856v-.055c0-4.352-3.174-7.91-7.554-7.91zm103.562 0c-4.38 0-7.5 3.503-7.5 7.856v.054c0 4.353 3.175 7.911 7.555 7.911s7.5-3.503 7.5-7.856v-.055c0-4.352-3.175-7.91-7.555-7.91zm-121.822.328h-4.845v8.431h4.736c3.175 0 5.255-1.697 5.255-4.216v-.054c0-2.738-2.053-4.16-5.146-4.16zm-35.67 0h-5.913v7.774h5.886c2.874 0 4.927-1.478 4.927-3.942v-.054c0-2.354-1.807-3.778-4.9-3.778z"
              transform="translate(.763 .896)"
            />
            <path
              fill="#FFE000"
              d="M143.889.22c2.326 0 4.353.603 6.077 1.698.465.274.93.849.93 1.67 0 1.095-.875 1.943-1.97 1.943-.411 0-.74-.109-1.068-.3-1.397-.822-2.71-1.287-4.024-1.287-1.615 0-2.464.74-2.464 1.67v.054c0 1.26.821 1.67 4.134 2.519 3.887 1.013 6.077 2.408 6.077 5.748v.055c0 3.805-2.902 5.94-7.035 5.94-2.519 0-5.064-.766-7.2-2.3-.465-.328-.794-.93-.794-1.587 0-1.095.876-1.944 1.972-1.944.547 0 .93.192 1.204.384 1.45 1.067 3.039 1.724 4.9 1.724 1.725 0 2.764-.684 2.764-1.806v-.055c0-1.068-.657-1.615-3.86-2.436-3.859-.986-6.35-2.053-6.35-5.859v-.054c0-3.477 2.792-5.776 6.707-5.776zm-45.58.165c.903 0 1.532.466 1.915 1.095l5.092 8.295 5.12-8.322c.437-.712 1.04-1.068 1.888-1.068h.465c1.177 0 2.108.93 2.108 2.108v15.22c0 1.177-.93 2.108-2.108 2.108-1.15 0-2.08-.959-2.08-2.108V8.159l-3.696 5.694c-.438.657-.985 1.068-1.752 1.068-.766 0-1.313-.41-1.751-1.068l-3.642-5.612v9.527c0 1.15-.93 2.053-2.08 2.053s-2.053-.903-2.053-2.053V2.493c0-1.177.93-2.108 2.108-2.108h.465zM126.45.194c1.15 0 1.971.63 2.437 1.67l6.679 15.083c.137.3.219.575.219.848 0 1.122-.876 2.026-1.999 2.026-.985 0-1.641-.575-2.025-1.451l-1.287-3.011h-8.43l-1.342 3.148c-.356.821-1.068 1.314-1.944 1.314-1.095 0-1.943-.877-1.943-1.97 0-.302.109-.603.247-.904l6.679-15.083c.465-1.04 1.313-1.67 2.463-1.67h.246zm-.191 5.118l-2.656 6.324h5.31l-2.654-6.324z"
              transform="translate(.763 .896)"
            />
          </g>
        </svg>
        <Typography className={styles.title} variant="subtitle2">
          Login
        </Typography>
        <Button onClick={onAuthenticate} variant="contained" color="primary" size="small">
          Acceder
        </Button>
      </Paper>
      {isDevEnv && (
        <LoginMock
          isOpen={isOpenLoginMock}
          onClose={onCloseLoginMock}
          authenticateDev={authenticateDev}
        />
      )}
    </div>
  )
}
